
    import { Component, Vue, Inject } from 'vue-property-decorator';
    import Footer from '../components/Footer.vue'
    import registered from './registered.vue'
    import iView from 'iview';
    import Util from '../lib/util'
    import AbpBase from '../lib/abpbase'
    @Component({
        components: { Footer,registered }
    })
    export default class Login extends AbpBase {
        loginModel = {
            userNameOrEmailAddress: '',
            password: '',
            rememberMe: false
        }
        registered(){
            this.registeredModalShow=true;
        }
        registeredModalShow:boolean=false;
        showChangeTenant: boolean = false
        async login() {
            (this.$refs.loginform as any).validate(async (valid: boolean) => {
                if (valid) {
                    await this.startLogin();
                }
            });
        }
        async startLogin() {
        this.$Message.loading({
            content: this.L('开始登录'),
            duration: 0
        })
        await this.$store.dispatch({
            type: 'app/login',
            data: this.loginModel
        })
        sessionStorage.setItem('rememberMe', this.loginModel.rememberMe ? '1' : '0');
        location.reload();
        }
        get tenant() {
            return this.$store.state.session.tenant;
        }
        rules = {
            userNameOrEmailAddress: [
                { required: true, message: this.L('账号不能为空'), trigger: 'blur' }
            ],
            password: [
                { required: true, message: this.L('密码不能为空'), trigger: 'blur' }
            ]
        }
        created() {
            Util.abp.multiTenancy.setTenantIdCookie(1);
            var name = abp.getQueryVariable("name");
            var passWord = abp.getQueryVariable("password");
            if (name && passWord) {
                this.loginModel.rememberMe = false;
                this.loginModel.userNameOrEmailAddress = decodeURI(name);
                this.loginModel.password = decodeURI(passWord);
                this.startLogin();
            }
        }
    }
